/**
 * Selector for interactive elements within a list item
 */
export const INTERACTIVE_ELEMENTS_SELECTOR =
    'a[href]:not([aria-hidden="true"]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]):not([aria-hidden="true"])';
